<template>
    <loading v-model:active="isLoading" :can-cancel="false" :on-cancel="onCancel" :is-full-page="fullPage" />
    <div class="container-fluid">
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><router-link to="/supplier">Fornecedores</router-link></li>
                <li class="breadcrumb-item active" aria-current="page">Editar fornecedor</li>
                <li class="breadcrumb-item active" aria-current="page">{{ supplier.name }}</li>
            </ol>
        </nav>
        <div class="row" v-if="enable_error_list">
            <div class="col-xl-12 col-md-12 col-sm-12">
                <div class="alert alert-danger">
                    <ol>
                        <li v-for="(error, index) in errors" :key="index">{{ error[0] }}</li>
                    </ol>
                </div>
            </div>
        </div>
        <div class="row mt-4">
            <div class="col-xl-12 col-md-12 col-sm-12">
                <ul class="nav nav-tabs" role="tablist">
                    <li class="nav-item">
                        <a href="#info" role="tab" data-toggle="tab" class="nav-link active"> Dados gerais </a>
                    </li>
                    <li class="nav-item">
                        <router-link :to="{
                            name: 'supplier_address_edit',
                            params: { id: supplier.id }
                        }" role="tab" data-toggle="tab" class="nav-link">
                            Endereço </router-link>
                    </li>
                    <li class="nav-item">
                        <router-link :to="{
                            name: 'supplier_fiscal_edit',
                            params: { id: supplier.id }
                        }" role="tab" data-toggle="tab" class="nav-link">
                            Dados fiscais </router-link>
                    </li>
                </ul>
                <div class="tab-content">
                    <div class="tab-pane active" role="tabpanel" id="info">
                        <div class="card shadow mb-4">

                            <!-- Card Header - Dropdown -->
                            <div class="card-body">
                                <form @submit="update">
                                    <fieldset>
                                        <legend>Dados Gerais</legend>
                                        <div class="row mt-3">
                                            <div class="col-xl-4 col-md-4 col-sm-12">
                                                <label for="">CPF / CNPJ*</label>
                                                <div class="input-group mb-3">
                                                    <input type="text" class="form-control"
                                                        placeholder="Ex: xx.xxx.xxx/xxxx-xx" v-model="supplier.document"
                                                        v-mask="['###.###.###-##', '##.###.###/####-##']"
                                                        @keypress="enableSearchCnpj()">

                                                </div>
                                            </div>
                                            <div class="col-xl-8 col-md-8 col-sm-12">
                                                <label for="">Nome / Razão Social*</label>
                                                <input type="text" class="form-control" placeholder="Ex: Empresa XYZ"
                                                    v-model="supplier.name">
                                            </div>
                                        </div>
                                        <div class="row mt-3">
                                            <div class="col-xl-3 col-md-3 col-sm-12">
                                                <label for="">Telefone</label>
                                                <input type="text" class="form-control"
                                                    placeholder="Ex: (xx)x.xxxx-xxxx" v-model="supplier.phone">
                                            </div>
                                            <div class="col-xl-3 col-md-3 col-sm-12">
                                                <label for="">Nome do contato</label>
                                                <input type="text" class="form-control"
                                                    placeholder="Ex: Francisco José Da Silva"
                                                    v-model="supplier.name_contact">
                                            </div>
                                            <div class="col-xl-6 col-md-6 col-sm-12">
                                                <label for="">E-mail</label>
                                                <input type="text" class="form-control"
                                                    placeholder="Ex: usuario@dominio.com" v-model="supplier.email">
                                            </div>
                                        </div>
                                    </fieldset>
                                    <br>
                                    <fieldset>
                                        <legend>Obvervações</legend>
                                        <div class="row mt-2 mb-4">
                                            <div class="col-lg-12 col-xs-12 col-sm-12">
                                                <editorText @update-text="updateObservation"
                                                    :modelValue="supplier.observation" placeholderSend="Sem observações"
                                                    ref="myChild"></editorText>
                                            </div>
                                        </div>
                                        <br> <br>
                                    </fieldset>
                                    <br>
                                    <div class="row">
                                        <div class="col-xl-12 col-md-12 col-sm-12">
                                            <button type="submit" :disabled='!isDisabled' class="btn btn-info"><i
                                                    class="fa fa-save"></i> Atualizar</button>
                                            <router-link to="/supplier" class="btn btn-danger ml-3"><i
                                                    class="fa fa-times"></i>
                                                Cancelar</router-link>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/api';
import { handleRequestErrors } from '@/handleErrors';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import editorText from '../util/editor-text.vue';

export default {

    components: { Loading, editorText },
    data() {
        return {
            isLoading: true,
            fullPage: true,
            supplier: {
                name: '',
                document: ''
            },
            enable_error_list: false,
            errors: []
        }
    },

    computed: {
        isDisabled: function () {
            return this.supplier.document != '' && this.supplier.name != '';
        }
    },
    mounted() {
        this.isLoading = false;
        this.getSupplier();
    },
    beforeMount() {
        const id = this.$route.params.id;
        this.supplier.id = id;
        this.getSupplier();
    },

    methods: {
        onCancel() { },
        getSupplier() {
            api.get('/supplier/' + this.supplier.id)
                .then((response) => {
                    this.isLoading = false;
                    this.supplier = response.data.supplier;
                    this.$refs.myChild.updateTextEditor(this.supplier.observation);
                }).catch(error => {
                    this.isLoading = false;
                    handleRequestErrors(error.status, error);
                })
        },

        updateObservation(observation) {
            this.supplier.observation = observation;
        },

        update(event) {
            event.preventDefault();
            this.enable_error_list = false;
            this.isLoading = true;
            api.put('/supplier/' + this.supplier.id, this.supplier)
                .then(() => {
                    this.isLoading = false;
                    this.$notify({
                        title: "Sucesso",
                        text: "Fornecedor atualizado com sucesso!",
                        type: 'success'
                    });
                }).catch(error => {
                    this.isLoading = false;
                    if (error.status == 422) {
                        let response_errors = error.response.data.errors;
                        this.errors = response_errors;
                        this.enable_error_list = true;
                    }
                    handleRequestErrors(error.status);
                })

        }
    }
}
</script>

<style lang="scss" scoped></style>